import React from "react";

import Container from 'react-bootstrap/Container';
import Row       from 'react-bootstrap/Row';
import Col       from 'react-bootstrap/Col';
import Alert     from 'react-bootstrap/Alert';

const Thanks = ( props ) => {
  return (
    <Container>
      <Row style={{margin: "100px 0px"}}>
        <Col md={{ span: 6, offset: 3}}
        >
          <Alert variant="success">
            <Alert.Heading>Solicitação enviada com sucesso!!!</Alert.Heading>
            <p>Aguarde, em breve entraremos em contato.</p>
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}
export default Thanks;